// ============================================================================
// ITALIAN TRANSLATIONS - JESUS IS NOT
// ============================================================================
// Chiarimenti su chi è Gesù (e chi non è)

export const jesusIsNot = [
  {
    category: "amore",
    text: "Gesù non è razzista - Ama tutti allo stesso modo, indipendentemente dalla loro origine",
    reference: "Giovanni 4:9 - La donna samaritana si meraviglia che Gesù le parli",
    context: "Gesù supera le barriere culturali e razziali del suo tempo"
  },
  {
    category: "esclusione",
    text: "Gesù non è esclusivo - Accoglie tutti, specialmente gli emarginati",
    reference: "Matteo 9:10-13 - Gesù mangia con pubblicani e peccatori",
    context: "Gesù cerca i perduti e i rifiutati della società"
  },
  {
    category: "giudizio",
    text: "Gesù non è condannatore - È venuto per salvare, non per condannare",
    reference: "Giovanni 3:17 - Dio non ha mandato il Figlio per condannare il mondo",
    context: "La missione di Gesù è la salvezza e il restauro"
  },
  {
    category: "violenza",
    text: "Gesù non è violento - Insegna l'amore per i nemici",
    reference: "Matteo 5:44 - Amate i vostri nemici",
    context: "Gesù rivoluziona il concetto di giustizia con l'amore radicale"
  },
  {
    category: "ricchezza",
    text: "Gesù non è materialista - Avverte contro l'amore per il denaro",
    reference: "Matteo 6:24 - Non potete servire Dio e Mammona",
    context: "Gesù dà priorità ai tesori celesti rispetto a quelli terreni"
  },
  {
    category: "orgoglio",
    text: "Gesù non è orgoglioso - Si umilia e serve",
    reference: "Giovanni 13:5 - Gesù lava i piedi ai suoi discepoli",
    context: "Gesù mostra che la grandezza sta nel servizio umile"
  },
  {
    category: "legalismo",
    text: "Gesù non è legalista - Pone la misericordia sopra il rituale",
    reference: "Matteo 12:7 - Voglio misericordia e non sacrificio",
    context: "Gesù critica il legalismo che dimentica il cuore della legge"
  },
  {
    category: "genere",
    text: "Gesù non è sessista - Onora e valorizza le donne",
    reference: "Giovanni 4:27 - I discepoli si meravigliano che parli con una donna",
    context: "Gesù sfida le norme patriarcali della sua cultura"
  },
  {
    category: "potere",
    text: "Gesù non è tiranno - Guida con amore ed esempio",
    reference: "Matteo 20:28 - Il Figlio dell'uomo è venuto per servire",
    context: "Gesù ridefinisce la leadership come servizio sacrificale"
  },
  {
    category: "vendetta",
    text: "Gesù non è vendicativo - Perdona e restaura",
    reference: "Luca 23:34 - Padre, perdona loro, perché non sanno quello che fanno",
    context: "Gesù pratica il perdono radicale anche sulla croce"
  },
  {
    category: "indifferenza",
    text: "Gesù non è indifferente - È commosso dalla sofferenza",
    reference: "Matteo 9:36 - Ebbe compassione della folla",
    context: "Gesù mostra profonda empatia per chi soffre"
  },
  {
    category: "élite",
    text: "Gesù non è elitario - Si circonda di persone comuni",
    reference: "Marco 1:16-20 - Gesù chiama pescatori come discepoli",
    context: "Gesù sceglie persone ordinarie per la sua missione straordinaria"
  },
  {
    category: "ipocrisia",
    text: "Gesù non è ipocrita - Vive ciò che insegna",
    reference: "Giovanni 8:46 - Chi di voi mi convince di peccato?",
    context: "Gesù sfida a trovare contraddizioni tra le sue parole e le sue azioni"
  },
  {
    category: "rigidità",
    text: "Gesù non è rigido - Adatta il suo insegnamento a ogni persona",
    reference: "Giovanni 3 - Gesù parla diversamente a Nicodemo che alla samaritana",
    context: "Gesù personalizza il suo messaggio secondo i bisogni di ciascuno"
  },
  {
    category: "tradizione",
    text: "Gesù non è tradizionalista cieco - Mette in discussione le tradizioni oppressive",
    reference: "Marco 7:13 - Annullate la parola di Dio con la vostra tradizione",
    context: "Gesù dà priorità allo spirito della legge rispetto alle tradizioni umane"
  },
  {
    category: "nazionalismo",
    text: "Gesù non è nazionalista - Il suo regno trascende i confini",
    reference: "Matteo 28:19 - Andate e fate discepoli di tutte le nazioni",
    context: "La missione di Gesù è universale, non limitata a un solo popolo"
  },
  {
    category: "divisione",
    text: "Gesù non è divisivo - Prega per l'unità dei credenti",
    reference: "Giovanni 17:21 - Che siano tutti uno",
    context: "Celebriamo le nostre diversità invece di creare guerre di parole"
  },
  {
    category: "verità",
    text: "Gesù non è bugiardo - Denuncia la menzogna e la manipolazione",
    reference: "Giovanni 8:44 - Il diavolo è padre della menzogna",
    context: "Gesù espone le menzogne e le manipolazioni che feriscono le anime"
  },
  {
    category: "generosità",
    text: "Gesù non è avaro - La sua generosità supera di gran lunga la decima",
    reference: "Luca 21:3 - Questa povera vedova ha messo più di tutti",
    context: "La generosità di Gesù è più forte dell'obbligo della decima"
  },
  {
    category: "giustizia",
    text: "Gesù non è complice del silenzio - Protegge con una sana giustizia",
    reference: "Matteo 18:6 - Chi scandalizza uno di questi piccoli",
    context: "Il silenzio che copre le colpe senza proteggere gli altri non è la saggezza di Gesù"
  }
];

export default jesusIsNot;
